<template>
    <v-flex xs12>
      <v-flex class="my-4 text-xs-center" v-if="moonInstance.length === 0">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-flex>
      <v-card>
        <v-card-title class="pb-3 px-2 layout row wrap">
          <h3 class="mx-3">{{$lang.header.moonInstances}}</h3>
          <v-checkbox
            color="primary"
            class="mx-1 mt-0"
            :label="$lang.labels.showActive"
            v-model="showActive"
            hide-details
          />
          <v-spacer />
          <v-text-field
            class="min-w max-w mx-3 pb-2"
            v-model="search"
            append-icon="search"
            :label="$lang.labels.search"
            hide-details
          />
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="showActive ? activeInstances : allInstances"
          :search="search"
          :loading="allInstances.length === 0"
          :rows-per-page-items="[50, 100, 250, 500, { text:'All' , value: -1 }]"
        >
        <v-progress-linear height="6" slot="progress" color="primary" indeterminate />
          <template slot="items" slot-scope="props">
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.currentVersion }}</td>
            <td class="text-xs-left">{{ formatDate(props.item.createdOn) }}</td>
            <td class="text-xs-left">{{ formatDate(props.item.lastContactOn) }}</td>
            <td class="text-xs-left">{{ props.item.status }}</td>
            <td class="text-xs-left">
              <v-btn class="primary mx-0 elevation-1" @click="moonInstance(props.item)">{{$lang.actions.edit}}</v-btn>
            </td>
          </template>
          <v-alert slot="no-results" :value="true" color="warning" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card>
    </v-flex>
</template>

<script>
  import {DateTime} from 'luxon';

  export default {
    data() {
      return {
        search: '',
        headers: [
          { text: this.$lang.labels.name, value: 'name', align: 'left' },
          { text: this.$lang.labels.currentVersion, value: 'currentVersion', align: 'left' },
          { text: this.$lang.labels.created, value: 'createdOn', align: 'left' },
          { text: this.$lang.header.contactedOn, value: 'lastContactOn', align: 'left' },
          { text: this.$lang.labels.status, value: 'status', align: 'left' },
          { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false },
        ],
        showActive: true,
        allInstances: [],
      }
    },
    computed: {
      activeInstances() {
        const instances = this.allInstances;
        const activeInstances = [];
        for (let i=0; instances.length > i; i++) {
          if (instances[i].status === 'active') {
            activeInstances.push(instances[i]);
          }
        }
        return activeInstances;
      },
    },
    methods: {
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd HH:mm');
      },
      moonInstance(instance) {
        this.$router.push({ name: 'moonInstanceDetails', params: {id: instance.id}});
      },
    },
    created() {
      this.$http.get('moon/instance')
        .then((res) => {
          if (res.body.status === 'Success') {
            this.allInstances = res.body.details;
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
    },
  };
</script>



// WEBPACK FOOTER //
// MoonInstances.vue?daa03a48